// Accept bare role arrays and the envelopes used by user endpoints.
export function roleNames (body) {
  if (Array.isArray(body)) return [...new Set(body.map(role => typeof role === 'string' ? role : role.name || role.roleName).filter(Boolean))]
  if (!body || typeof body !== 'object') throw new Error('The server returned an invalid roles response.')
  if (body.success === false || body.isSuccess === false) throw new Error(body.message || 'The roles request failed.')
  return roleNames(body.roles || body.data || body.outputObject)
}
